// document.addEventListener('DOMContentLoaded', () => {
//     const stickyATC = document.querySelector('#md-sticky-atc');
//     const productSection = document.querySelector('.product');
//     const img = stickyATC.querySelector('.product-content img');
//     const btn = stickyATC.querySelector('[name="add"]');
//     const selectField = stickyATC.querySelector('select[name="id"]');

//     const observer = new IntersectionObserver(function(entries) {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//         stickyATC.classList.remove('show');
//         document.documentElement.style.paddingBottom = '0';
//         } else {
//         stickyATC.classList.add('show');
//         document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
//         document.documentElement.style.height = 'auto';
//         }
//     });
//     }, {
//     root: null,
//     threshold: 0
//     });

//     if (productSection) {
//     observer.observe(productSection);
//     }

//     if (selectField) {
//         selectField.addEventListener('change', () => {
//             // img.setAttribute('src', selectField.options[selectField.selectedIndex].dataset.img);
//             const selectedOption = selectField.options[selectField.selectedIndex];

//             // Update image
//             img.setAttribute('src', selectedOption.dataset.img);

//             // Get prices from data attributes
//             const price = selectedOption.dataset.price;
//             const comparePrice = selectedOption.dataset.comparePrice;

//             // Update DOM
//             const sellingPriceEl = document.querySelector('.selling_price');
//             const comparePriceEl = document.querySelector('.compare_at_price');

//             if (sellingPriceEl) {
//                 sellingPriceEl.textContent = price;
//             }

//             if (comparePriceEl) {
//                 comparePriceEl.textContent = comparePrice;
//             }
//         });
//     }

//     document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
//     const value = Number(e.target.value);
//     if (value) {
//         selectField.value = value;
//     }
//     });
// });


/* ============================================================
   sticky_add_to_cart.js
   
   The sticky button (type="button", id="sticky-atc-btn") has NO
   form around it. On click it:
     1. Validates dog-tag fields (only on dog-tag product)
     2. Syncs variant + quantity to the MAIN product form
     3. Calls mainSubmitBtn.click() so the main product-form
        custom element runs the fetch → cart-notification popup
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var stickyBar  = document.querySelector('#md-sticky-atc');
  if (!stickyBar) return;

  var productSection = document.querySelector('.product');
  var stickyImg      = stickyBar.querySelector('.product-content img');
  var stickyBtn      = document.querySelector('#sticky-atc-btn');
  var stickySelect   = document.querySelector('#sticky_atc_variants');
  var stickyQtyInput = stickyBar.querySelector('.quantity__input');

  /* ── Find main form elements ─────────────────────────────────── */
  function getMainSubmitBtn() {
    // The main ATC button — lives inside product-info, NOT in sticky bar
    var btn = document.querySelector(
      'product-info product-form [type="submit"][name="add"]'
    );
    if (!btn) btn = document.querySelector(
      '.main-product-section product-form [type="submit"][name="add"]'
    );
    if (!btn) btn = document.querySelector(
      'product-form [type="submit"][name="add"]'
    );
    return btn;
  }

  function getMainQtyInput() {
    var inputs = document.querySelectorAll('.quantity__input');
    // Return the one that is NOT inside the sticky bar
    for (var i = 0; i < inputs.length; i++) {
      if (!stickyBar.contains(inputs[i])) return inputs[i];
    }
    return null;
  }

  function getMainVariantInput() {
    var inputs = document.querySelectorAll('product-form input[name="id"], product-form [name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!stickyBar.contains(inputs[i])) return inputs[i];
    }
    return null;
  }

  /* ── Intersection Observer: show/hide sticky bar ─────────────── */
  // Only show sticky bar on dog-tag product if fields are filled,
  // but always show/hide based on product section visibility.
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('show');
        document.documentElement.style.paddingBottom = '0';
      } else {
        stickyBar.classList.add('show');
        document.documentElement.style.paddingBottom = stickyBar.clientHeight + 'px';
        document.documentElement.style.height = 'auto';
      }
    });
  }, { root: null, threshold: 0 });

  if (productSection) observer.observe(productSection);

  /* ── Sticky variant select: update image + price ─────────────── */
  if (stickySelect) {
    stickySelect.addEventListener('change', function () {
      var opt       = stickySelect.options[stickySelect.selectedIndex];
      var sellingEl = document.querySelector('.selling_price');
      var compareEl = document.querySelector('.compare_at_price');
      if (stickyImg) stickyImg.setAttribute('src', opt.dataset.img || '');
      if (sellingEl) sellingEl.textContent = opt.dataset.price || '';
      if (compareEl) compareEl.textContent = opt.dataset.comparePrice || '';
    });
  }

  /* ── Quantity +/- in sticky bar ──────────────────────────────── */
  stickyBar.querySelectorAll('.quantity__button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(stickyQtyInput.value, 10) || 1;
      stickyQtyInput.value = btn.name === 'plus' ? val + 1 : Math.max(1, val - 1);
    });
  });

  /* ── Keep sticky select in sync when main variant picker changes  */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id' && !stickyBar.contains(e.target)) {
      var newId = e.target.value;
      if (stickySelect) stickySelect.value = newId;
      if (stickySelect) {
        var opt = stickySelect.querySelector('option[value="' + newId + '"]');
        if (opt) {
          var sellingEl = document.querySelector('.selling_price');
          var compareEl = document.querySelector('.compare_at_price');
          if (stickyImg) stickyImg.setAttribute('src', opt.dataset.img || '');
          if (sellingEl) sellingEl.textContent = opt.dataset.price || '';
          if (compareEl) compareEl.textContent = opt.dataset.comparePrice || '';
        }
      }
    }
  });

  /* ── Sticky ATC button click ─────────────────────────────────── */
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {

      /* 1. Dog-tag field validation */
      var dogTagBlock = document.querySelector('#dog-tag-fields');
      if (dogTagBlock && window.DogTagFields) {
        if (!window.DogTagFields.validate()) {
          window.DogTagFields.scrollToFields();
          return; // stop — do not add to cart
        }
      }

      /* 2. Sync variant from sticky select → main form hidden input */
      if (stickySelect) {
        var mainIdInput = getMainVariantInput();
        if (mainIdInput) {
          mainIdInput.value = stickySelect.value;
          mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      /* 3. Sync quantity → main form */
      var mainQty = getMainQtyInput();
      if (mainQty && stickyQtyInput) {
        mainQty.value = stickyQtyInput.value || 1;
      }

      /* 4. Show loading state on sticky button */
      var spinner = stickyBtn.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      stickyBtn.setAttribute('aria-disabled', 'true');

      /* 5. Click the MAIN submit button → runs through main product-form
            custom element which has cart-notification properly wired up */
      var mainBtn = getMainSubmitBtn();
      if (mainBtn) {
        mainBtn.click();
      }

      /* 6. Re-enable sticky button after processing */
      setTimeout(function () {
        if (spinner) spinner.classList.add('hidden');
        stickyBtn.removeAttribute('aria-disabled');
      }, 1500);
    });
  }
});